<div>
  <a class="logoContainer" [href]= "logoUrl" rel="noopener" target="_blank">
    <img id="logo" class="logo img-circle" alt="logo" [src]=bannerLogo />
  </a>
  <div class="TitleBar container banner mat-primary">
    <div class="flexRow">
      <a role="button" class="title flex-item" [href]="titleUrl" rel="noopener" target="_blank">
        <h6>{{titleText}}</h6>
      </a>
      <div *ngIf="themeList.length > 1" class="theme-button">
        <!-- <button color="primary" type="button" class="themeButton" mat-raised-button [matMenuTriggerFor]="themeMenu" matTooltip="Map Themes"> -->
          <button color="primary" type="button" class="themeButton" mat-raised-button matTooltip="Map Themes" (click)="openTocThemes()">
         <!--  <span class="icon esri-icon-media"></span> -->
         <span> Themes<mat-icon>expand_more</mat-icon></span>
        </button>
        <!-- <mat-menu #themeMenu> -->
          <!-- <button mat-menu-item *ngFor="let theme of themeList" (click)="themeClick(theme)" [disabled]="theme === currentTheme">{{theme}}</button> -->
          <!-- <button mat-menu-item *ngFor="let theme of themeList" (click)="themeClick(theme)" >{{theme}}</button> -->
        <!-- </mat-menu> -->
      </div>
      <div class="menu">
        <a  *ngIf="appContactInfo" class="pageBtn" role="button" id="contactUs"
            (click)="showDialog(appContactInfo)" matTooltip="Contact Us" aria-label="Contact Us">
          <mat-icon>contact_mail</mat-icon>
        </a>
        <a *ngIf="appWebLinks && appWebLinks.length > 0" class="pageBtn" role="button" id="weblinks"
            [matMenuTriggerFor]="webLinksList" matTooltip="Web Links" aria-label="Web Links">
          <mat-icon>menu</mat-icon>
        </a>
          <mat-menu #webLinksList >
          <div *ngFor = "let webLink of appWebLinks">
            <br>
            <a *ngIf=webLink.url [attr.href]="webLink.url" target="_blank">
              {{webLink.name}}
            </a>
            <a *ngIf=webLink.text class="clickableLink" role="link" (click)="showDialog(webLink.text)">
              {{webLink.name}}
            </a>
          </div>
        </mat-menu>

        <a matTooltip="2D Map" class="pageBtn routeBtn" role="button" routerLink="2d-view" aria-label="2D view"
           routerLinkActive="active" (click)="pageChange('2d-view', null)">
          <mat-icon>map</mat-icon>
        </a>
        <a matTooltip="3D globe" class="pageBtn routeBtn" role="button" routerLink="3d-view" aria-label="3D view"
           routerLinkActive="active" (click)="pageChange('3d-view', null)">
          <mat-icon>3d_rotation</mat-icon>
        </a>
        <a class="pageBtn help routeBtn" role="button" id="help" [routerLink]="currentRoute + '/help'" routerLinkActive="active"
            (click)="pageChange('help', null)" matTooltip="Help Page" aria-label="Help page">
          <mat-icon>help</mat-icon>
        </a>
      </div>
      <div id="searchContainer"></div>
    </div>
  </div>
</div>
